import { render, staticRenderFns } from "./site-nav.vue?vue&type=template&id=23ebb3b0&"
import script from "./site-nav.vue?vue&type=script&lang=js&"
export * from "./site-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports